import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const BULLETINPAIE_URL = `${backendUrl}/api/bulletinpaie/`;

class BulletinpaieService {
	async getAllBulletinpaies() {
		try {
			const response = await axios.get(BULLETINPAIE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getBulletinpaie(id) {
		return axios.get(`${BULLETINPAIE_URL}${id}/`);
	}

	createBulletinpaie(data) {
		return axios.post(BULLETINPAIE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du bulletin de paie', error);
			throw error;
		});
	}

	updateBulletinpaie(id, data) {
		return axios.put(`${BULLETINPAIE_URL}${id}/`, data);
	}

	deleteBulletinpaie(id) {
		return axios.delete(`${BULLETINPAIE_URL}${id}/`);
	}

	getBulletinpaieOptions() {
		return this.getAllBulletinpaies().then((bulletinpaies) => {
			const options = bulletinpaies.map((bulletinpaie) => ({
				value: bulletinpaie.id,
				label: bulletinpaie.categorie.toUpperCase()
			}));
			return options;
		});
	}
}

export default new BulletinpaieService();
